import { Box, Container, Grid, Tab, Tabs, Typography } from '@mui/material';
import React, { useState } from 'react';
import PeriodTimeline from '../../lib/components/PeriodTimeline';
import { useSchoolStore } from '../../stores/schoolStore';
import { DayOfWeek } from '../../types';

export const SchoolDay: React.FC = () => {
  const { periods, activities } = useSchoolStore();
  const [selectedDay, setSelectedDay] = useState<DayOfWeek>('monday');

  const days: DayOfWeek[] = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday'];
  const dayLabels: Record<DayOfWeek, string> = {
    monday: 'Monday',
    tuesday: 'Tuesday',
    wednesday: 'Wednesday',
    thursday: 'Thursday',
    friday: 'Friday',
  };

  return (
    <Container maxWidth="xl" sx={{ mt: 4, mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        School Day Configuration
      </Typography>

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs
          value={selectedDay}
          onChange={(_, newValue) => setSelectedDay(newValue)}
          variant="scrollable"
          scrollButtons="auto"
        >
          {days.map((day) => (
            <Tab key={day} label={dayLabels[day]} value={day} />
          ))}
        </Tabs>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12}>
          <PeriodTimeline
            periods={periods}
            activities={activities}
            selectedDay={selectedDay}
            showDuration={true}
            interactive={false}
          />
        </Grid>
      </Grid>
    </Container>
  );
};

export default SchoolDay;
